import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { routerMiddleware } from 'connected-react-router'
import { apiMiddleware } from 'redux-api-middleware'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import AzureBlockUpload from 'abu-redux-middleware'

import { APICallAbortion, APIErrors, APIHeaders, APIUrl, auth, socket } from './middleware'
import createRootReducer from '../reducers'
import { history } from '../services/Router'

const rootReducer = createRootReducer(history)
const router = routerMiddleware(history)
const enhancer = applyMiddleware(thunk, router, auth, APIUrl, APIHeaders, APICallAbortion, AzureBlockUpload, socket, apiMiddleware, APIErrors)

// Redux persistance
const persistConfig = {
    key: 'root',
    storage,
    stateReconciler: autoMergeLevel2, // see "Merge Process" section for details.
    blacklist: ['promos', 'credits'],
}

const pReducer = persistReducer(persistConfig, rootReducer)

const configureStore = (initialState) => createStore(pReducer, initialState, enhancer)

export default { configureStore, history }
